// bootstrap import
// import "bootstrap"

import Loader from './parts/Loader.js'
import Navigation from './parts/Navigation.js'
import Smooth from './parts/Smooth.js'
import { CaseSlider } from './parts/CaseSlider'

import Accordion from './parts/Accordion.js'
import MouseDot from './parts/MouseDot.js'
import MouseStalker from './parts/MouseStalker.js'
// import Equipment from './parts/Equipment.js'

import Swiper from 'swiper/bundle'
import 'swiper/swiper-bundle.css'

// import { gsap } from 'gsap'
// import { ScrollSmoother } from 'gsap/ScrollSmoother'
// import { ScrollTrigger } from 'gsap/ScrollTrigger'

// スムーススクロール実装
//----------------------------------------------------
// gsap.registerPlugin(ScrollTrigger, ScrollSmoother)

// ----------------------------------------------------
// ナビゲーション
// ----------------------------------------------------
new Navigation({
  navId: 'site_navigation',
  humId: 'hum_toggle',
  linkSelector: '#site_navigation a',
  breakPoint: 1025,
  pcNavigation: false,
})

// ----------------------------------------------------
// ローダー初期化
// ----------------------------------------------------
const loader = new Loader({
  endFn: () => {
    console.log('Loader finished')
  },
})

// ロード完了を仮定（実際は画像やデータ読み込み完了で呼ぶ）
window.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    loader.complete()
  }, 4000)
})

// ----------------------------------------------------
// ローダー完了後に各機能を初期化
// ----------------------------------------------------
window.addEventListener('loader:complete', () => {
  new Smooth({ linkTarget: '.nav_link a[href*="#"]' })
  new Navigation({
    navId: 'site_navigation',
    humId: 'hum_toggle',
    linkSelector: '#site_navigation a',
    breakPoint: 1025,
    pcNavigation: true,
  })
  // new CaseSlider()
  new MouseStalker()
  new Accordion()
})

// document.addEventListener('DOMContentLoaded', () => {
// ----------------------------
// 回転画像カーソル
// ----------------------------
// const stalker = new MouseStalker({
//   stalkerClassName: 'mouse_stalker',
//   scrub: 0.3, // 追従速度
//   rotationSpeed: -0.8, // 回転速度
// })

// // hover対象（aタグ・ボタン・data-hover）
// const hoverTargets = document.querySelectorAll('a, button, [data-hover]')
// hoverTargets.forEach((el) => {
//   el.addEventListener('mouseenter', () => stalker.el.classList.add('hover'))
//   el.addEventListener('mouseleave', () =>
//     stalker.el.classList.remove('hover')
//   )
// })

// ----------------------------
// ドットカーソル
// ----------------------------
//   const dot = new MouseDot({
//     color: 'ddd',
//     size: 12,
//     scrub: 0.9, // 追従速度
//   })
//   dot.el.style.backgroundColor = '#ddd'
//   dot.el.style.mixBlendMode = 'difference'
// })

// ----------------------------
// IntersectionObserver系（fade-upなど）
// ----------------------------
const fadeEls = document.querySelectorAll('.fade-up, .fade-left')
const observer = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-inview')
        observer.unobserve(entry.target)
      }
    })
  },
  { threshold: 0.1 }
)
fadeEls.forEach((el) => observer.observe(el))

// ----------------------------
// Swiper初期化
// ----------------------------

const swiper = new Swiper('.mySwiper', {
  loop: true,
  pagination: { el: '.swiper-pagination', clickable: true },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  slidesPerView: 3,
  spaceBetween: 30,
})

// ----------------------------
// ナビゲーションのスクロール判定（上スクロールで表示、下スクロールで非表示）
// ----------------------------
const nav = document.querySelector('.navi-container')
if (nav) {
  let lastScrollY = window.scrollY
  let timeoutId: number

  window.addEventListener('scroll', () => {
    clearTimeout(timeoutId)
    const currentScrollY = window.scrollY

    if (currentScrollY > lastScrollY && currentScrollY > 50) {
      nav.classList.add('navi-hidden')
    } else {
      nav.classList.remove('navi-hidden')
    }
    lastScrollY = currentScrollY

    timeoutId = window.setTimeout(() => {
      nav.classList.remove('navi-hidden')
    }, 1000)
  })
}
// ----------------------------
// FAQアコーディオン
// ----------------------------
const faqItems = document.querySelectorAll('.faq-item')
faqItems.forEach((item) => {
  const question = item.querySelector('.faq-question')
  if (question) {
    question.addEventListener('click', () => {
      item.classList.toggle('open')
    })
  }
})

// ----------------------------
// 画像クリックで非表示
// ----------------------------
const stacks = document.querySelectorAll('.image-stack')
stacks.forEach((stack) => {
  stack.addEventListener('click', () => {
    stack.classList.toggle('active')
  })
})

// ----------------------------
// ホバーで広がるアイテム
// ----------------------------
document.querySelectorAll('.item').forEach((item) => {
  item.addEventListener('click', () => {
    document
      .querySelectorAll('.item')
      .forEach((i) => i.classList.remove('active'))
    item.classList.add('active')
  })
})

// ----------------------------
// ホバーリンク（画像とリンク連動）
// ----------------------------
document.querySelectorAll('.job-card_inner').forEach((card) => {
  const imgs = card.querySelectorAll('.job-card_media .job-card_img-link')
  const links = card.querySelectorAll('.job-card_links .job-card_link')

  // 🔹 リンクが1つだけの場合
  if (links.length === 1) {
    const link = links[0]

    imgs.forEach((imgLink) => {
      imgLink.addEventListener('mouseenter', () => {
        imgLink.classList.add('hover')
        link.classList.add('hover')
      })

      imgLink.addEventListener('mouseleave', () => {
        imgLink.classList.remove('hover')
        link.classList.remove('hover')
      })
    })

    link.addEventListener('mouseenter', () => {
      link.classList.add('hover')
      imgs.forEach((img) => img.classList.add('hover'))
    })

    link.addEventListener('mouseleave', () => {
      link.classList.remove('hover')
      imgs.forEach((img) => img.classList.remove('hover'))
    })

    return
  }

  // 🔹 通常（画像とリンクが同数）
  imgs.forEach((imgLink, i) => {
    imgLink.addEventListener('mouseenter', () => {
      imgLink.classList.add('hover')
      links[i].classList.add('hover')
    })
    imgLink.addEventListener('mouseleave', () => {
      imgLink.classList.remove('hover')
      links[i].classList.remove('hover')
    })
  })

  links.forEach((link, i) => {
    link.addEventListener('mouseenter', () => {
      link.classList.add('hover')
      imgs[i].classList.add('hover')
    })
    link.addEventListener('mouseleave', () => {
      link.classList.remove('hover')
      imgs[i].classList.remove('hover')
    })
  })
})

// ----------------------------
// CASEセクションスライダー（独立クラス使用）
// ----------------------------
const caseSlider = new CaseSlider()
;(window as any).caseSlider = caseSlider

// ----------------------------
// equipment建物制御
// ----------------------------
// equipment.ts (refactored)
document.addEventListener('DOMContentLoaded', () => {
  const container = document.querySelector<HTMLElement>('.room-container')
  if (!container) return

  const rooms = Array.from(container.querySelectorAll<HTMLElement>('.room'))
  const ladder = container.querySelector<HTMLElement>('.ladder') || null
  const modalImages: string[] = (window as any).equipmentModalImages || []
  const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0

  // -----------------------------
  // ラベル用テキスト
  // -----------------------------
  const roomDescriptions: Record<string, string> = {
    room1: '電気通信工事業',
    // room2: 'インターホンの設計・施工',
    room3: '電気工事業',
    // room4: 'その他の電気設備の工事',
    room5: '消防施設工事業',
    // room6: '消防設備の設計・施工',
  }

  const floorDescriptions: Record<string, string> = {
    // '1': '1階',
    // '2': '2階',
    // '3': '3階',
  }

  // -----------------------------
  // ラベル生成
  // -----------------------------
  rooms.forEach((room) => {
    const roomId = room.id
    const floor = room.dataset.floor || ''
    const roomText = roomDescriptions[roomId]
    const floorText = floorDescriptions[floor] || `${floor}階`
    const finalText = roomText ? roomText : floorText
    if (!roomText && Object.values(roomDescriptions).some((v) => v)) {
      return
    }

    // ラベル生成
    let label = room.querySelector<HTMLElement>('.room-label')
    if (!label) {
      label = document.createElement('div')
      label.className = 'room-label'
      room.appendChild(label)
    }

    label.textContent = finalText
    label.classList.remove('visible')
  })
  // -----------------------------
  // ラベル表示/非表示
  // -----------------------------
  const setLabels = (floor: string) => {
    rooms.forEach((r) => {
      const label = r.querySelector<HTMLElement>('.room-label')
      if (!label) return
      label.classList.toggle(
        'visible',
        container.classList.contains('show-all') || r.dataset.floor === floor
      )
    })
  }

  const clearLabels = () => {
    rooms.forEach((r) => {
      r.querySelector<HTMLElement>('.room-label')?.classList.remove('visible')
    })
  }

  // -----------------------------
  // フロア制御
  // -----------------------------
  const setActiveFloor = (floor: string) => {
    container.classList.remove(
      ...Array.from(container.classList).filter((c) =>
        c.startsWith('focus-floor-')
      )
    )
    container.classList.remove('show-all')
    container.classList.add(`focus-floor-${floor}`)

    rooms.forEach((r) =>
      r.classList.toggle('is-active', r.dataset.floor === floor)
    )
    if (ladder && ladder.dataset.floor)
      ladder.classList.toggle('is-active', ladder.dataset.floor === floor)

    setLabels(floor)
  }

  const clearFocus = () => {
    container.classList.remove(
      ...Array.from(container.classList).filter((c) =>
        c.startsWith('focus-floor-')
      )
    )
    container.classList.add('show-all')

    rooms.forEach((r) => r.classList.remove('is-active'))
    if (ladder) ladder.classList.remove('is-active')

    setLabels('')
  }

  // -----------------------------
  // アンカーマップ
  // -----------------------------
  const anchorFloorMap: Record<string, string> = {
    anchor01: '1',
    anchor02: '2',
    anchor03: '3',
  }

  const getInitialFloorFromHash = (): string => {
    const hash = location.hash.replace('#', '')
    return hash && anchorFloorMap[hash] ? anchorFloorMap[hash] : '3'
  }

  // -----------------------------
  // モーダル表示
  // -----------------------------
  const openModal = (images: string[]) => {
    const existing = document.querySelector('.modal')
    if (existing) existing.remove()

    const modal = document.createElement('div')
    modal.className = 'modal'
    modal.innerHTML = `
      <div class="modal-content">
        <button class="close">閉じる</button>
        <div class="image-grid">
          ${images
            .slice(0, 6)
            .map(
              (src) => `<div class="image-cell"><img src="${src}" alt=""></div>`
            )
            .join('')}
        </div>
      </div>
    `
    document.body.appendChild(modal)
    requestAnimationFrame(() => modal.classList.add('is-visible'))

    const closeModal = () => {
      modal.classList.remove('is-visible')
      modal.addEventListener('transitionend', () => modal.remove(), {
        once: true,
      })
    }

    modal.querySelector('.close')?.addEventListener('click', closeModal)
    modal.addEventListener('click', (e) => {
      if (e.target === modal) closeModal()
    })
  }

  // -----------------------------
  // 初期ロード処理
  // -----------------------------

  let hoverDisabled = true

  window.addEventListener('load', () => {
    const initialFloor = getInitialFloorFromHash()
    container.classList.add('disable-hover') // ホバー無効

    requestAnimationFrame(() => {
      container.classList.add('disable-hover')
    })

    setActiveFloor(initialFloor)
    setTimeout(() => container.classList.remove('disable-hover'), 1500)

    const hash = location.hash.replace('#', '')
    if (hash) {
      const target = document.getElementById(hash)
      if (target) {
        const scrollToTarget = () => {
          const rect = target.getBoundingClientRect()
          window.scrollTo({
            top: window.pageYOffset + rect.top,
            behavior: 'instant',
          })
        }
        setTimeout(scrollToTarget, 50)
        setTimeout(scrollToTarget, 1350)
      }
    }

    setTimeout(
      () => window.addEventListener('scroll', clearFocus, { passive: true }),
      50
    )
  })

  // -----------------------------
  // PCホバー
  // -----------------------------
  if (!isTouch) {
    let currentFloor = getInitialFloorFromHash()
    const illustrationContainer = document.querySelector<HTMLElement>(
      '.equipment_illustration'
    )
    const hoverTargets = Array.from(
      container.querySelectorAll<HTMLElement>('.room, .ladder')
    )

    const maintainFloor = (floor: string) => setActiveFloor(floor)

    hoverTargets.forEach((el) => {
      const floor = el.dataset.floor || ''
      el.addEventListener('mouseenter', () => {
        if (container.classList.contains('disable-hover')) return
        maintainFloor(floor)
        currentFloor = floor
      })
      el.addEventListener('mouseleave', () => {
        setTimeout(() => {
          const stillInside =
            hoverTargets.some((r) => r.matches(':hover')) ||
            container.matches(':hover') ||
            illustrationContainer?.matches(':hover')
          if (!stillInside) clearFocus()
          else maintainFloor(currentFloor)
        }, 60)
      })
    })

    container.addEventListener('mouseleave', () => {
      setTimeout(() => {
        const stillInsideIllustration = illustrationContainer?.matches(':hover')
        if (!stillInsideIllustration) clearFocus()
        else maintainFloor(currentFloor)
      }, 60)
    })

    illustrationContainer?.addEventListener('mouseleave', clearFocus)
  }

  // -----------------------------
  // クリック処理
  // -----------------------------
  declare global {
    interface Window {
      modalRoomImages?: string[]
      modalAlarmImages?: string[]
      modalLadderImages?: string[]
    }
  }
  const room6 = document.getElementById('room6')
  const ladderEl = document.querySelector<HTMLElement>(
    '.room-container .ladder'
  )

  if (room6) {
    const boxA = room6.querySelector<HTMLElement>('.box-a')
    const boxB = room6.querySelector<HTMLElement>('.box-b')

    boxA?.addEventListener('click', (e) => {
      e.stopPropagation()
      console.log('boxA clicked (modal-room)')
      if (window.modalRoomImages && window.modalRoomImages.length > 0)
        openModal(window.modalRoomImages)
      else console.warn('modal-roomに画像が登録されていません')
    })

    boxB?.addEventListener('click', (e) => {
      e.stopPropagation()
      console.log('boxB clicked (modal-alarm)')
      if (window.modalAlarmImages && window.modalAlarmImages.length > 0)
        openModal(window.modalAlarmImages)
      else console.warn('modal-alarmに画像が登録されていません')
    })
  }

  ladderEl?.addEventListener('click', (e) => {
    e.stopPropagation()
    console.log('ladder clicked (modal-ladder)')
    if (window.modalLadderImages && window.modalLadderImages.length > 0)
      openModal(window.modalLadderImages)
    else console.warn('modal-ladderに画像が登録されていません')
  })

  // ----------------------------
  // SPテキストクリック処理
  // ----------------------------
  const spTexts = document.querySelectorAll<HTMLElement>(
    '.equipment_illustration_sp_container_text'
  )

  spTexts.forEach((textEl) => {
    textEl.addEventListener('click', () => {
      const modalType = textEl.dataset.modalType

      let images: string[] | undefined

      switch (modalType) {
        case 'modal-alarm':
          images = window.modalAlarmImages
          break
        case 'modal-room':
          images = window.modalRoomImages
          break
        case 'modal-ladder':
          images = window.modalLadderImages
          break
        default:
          console.warn(`不明なモーダルタイプ: ${modalType}`)
          return
      }

      if (images && images.length > 0) {
        console.log(`${modalType} clicked (SP text)`) // デバッグ
        openModal(images)
      } else {
        console.warn(`${modalType} に画像が登録されていません`)
      }
    })
  })
})

// -----------------------------
// 投稿:戻るボタン
// -----------------------------
document.addEventListener('DOMContentLoaded', () => {
  const STORAGE_KEY = 'last_topics_url'
  if (location.pathname.includes('/topics')) {
    sessionStorage.setItem(STORAGE_KEY, location.href)
  }
  const backBtn = document.getElementById(
    'js-back-btn'
  ) as HTMLAnchorElement | null
  const savedUrl = sessionStorage.getItem(STORAGE_KEY)

  if (backBtn && savedUrl) {
    backBtn.href = savedUrl
  }
})
// -----------------------------
//　workページスライダー
// -----------------------------

// document.addEventListener('DOMContentLoaded', () => {
//   const workSwiper = new (window as any).Swiper(
//     '.section_work_title-block_text_slide',
//     {
//       modules: [(window as any).Swiper.Autoplay],
//       slidesPerView: 'auto',
//       spaceBetween: 10,
//       loop: true,
//       speed: 20000,
//       autoplay: {
//         delay: 0,
//         disableOnInteraction: false,
//       },
//       allowTouchMove: false,
//     }
//   )
// })

// -----------------------------
//　お問い合わせページ
// -----------------------------
document.addEventListener(
  'wpcf7mailsent',
  function (event) {
    wrapRequiredText()
  },
  false
)

document.addEventListener('DOMContentLoaded', function () {
  wrapRequiredText()
})

function wrapRequiredText() {
  const form = document.querySelector('.wpcf7-form')
  if (!form) return
  const targets = form.querySelectorAll('label, p')

  targets.forEach((target) => {
    let targetHtml = target.innerHTML
    const regex = /（必須）/g
    const replacement = '<span class="required-text">（必須）</span>'

    if (targetHtml.match(regex)) {
      if (targetHtml.indexOf(replacement) === -1) {
        target.innerHTML = targetHtml.replace(regex, replacement)
      }
    }
  })
}
